import { createApp } from 'vue';
import { createPinia } from 'pinia'
const pinia = createPinia()
import App from './App.vue';
import router from './router';

import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'bootstrap/scss/bootstrap.scss';
import './styles/core.scss';
import 'aos/dist/aos.css';
import AOS from 'aos';

const app = createApp(App)

app.use(pinia)
app.use(router)
app.mount('#app')

AOS.init();